import moment from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'


moment.extend(relativeTime);
moment.extend(isSameOrAfter);
moment.extend(isSameOrBefore);

export default moment;
